(() => {
  const sections = document.querySelectorAll('.main-product-bundle');
  sections.forEach((section) => {
    const radios = section.querySelectorAll('.fp-gallery__radio');
    const thumbs = section.querySelector('[data-fp-thumbs]');
    const prev = section.querySelector('[data-fp-arrow="prev"]');
    const next = section.querySelector('[data-fp-arrow="next"]');

    const getCheckedIndex = () => {
      let idx = 0;
      radios.forEach((r, i) => {
        if (r.checked) idx = i;
      });
      return idx;
    };

    function centerThumbInStrip(thumb) {
      if (!thumbs || !thumb) return;
      const tRect = thumb.getBoundingClientRect();
      const rRect = thumbs.getBoundingClientRect();
      const offsetWithin = (tRect.left + tRect.width / 2) - rRect.left;
      const target = thumbs.scrollLeft + offsetWithin - thumbs.clientWidth / 2;
      const max = Math.max(0, thumbs.scrollWidth - thumbs.clientWidth);
      thumbs.scrollTo({ left: Math.max(0, Math.min(target, max)), behavior: 'smooth' });
    }

    const getVisibleIndices = () =>
      Array.from(radios)
        .map((r, i) => (r.classList.contains('fp-gallery__radio--hidden') ? -1 : i))
        .filter((i) => i !== -1);

    const setIndex = (idx) => {
      if (!radios.length) return;
      const visible = getVisibleIndices();
      if (!visible.length) return;
      const checkedIdx = getCheckedIndex();
      let pos = visible.indexOf(checkedIdx);
      if (pos === -1) pos = 0;
      const delta = idx - checkedIdx;
      const nextPos = ((pos + Math.sign(delta)) % visible.length + visible.length) % visible.length;
      const target = visible[nextPos];
      radios[target].checked = true;
      radios[target].dispatchEvent(new Event('change', { bubbles: true }));
      if (thumbs) centerThumbInStrip(thumbs.children[target]);
    };

    if (prev) prev.addEventListener('click', () => setIndex(getCheckedIndex() - 1));
    if (next) next.addEventListener('click', () => setIndex(getCheckedIndex() + 1));

    /* === Color-tagged gallery filter ===
       Each Custom image block can carry a 'Variant color' value; the SSR stamps
       data-fp-color on the radio/slide/thumb. When the selected swatch matches
       the tag (case-insensitive) the slide is shown; untagged slides always
       show. Mirrors the homepage featured-product-lotus implementation. */
    const slides = section.querySelectorAll('.fp-gallery__slide');
    const thumbList = thumbs ? thumbs.querySelectorAll('.fp-gallery__thumb') : [];
    const hasColorTag = Array.from(radios).some((r) => (r.dataset.fpColor || '').length > 0);

    function filterGalleryByColor(color) {
      if (!hasColorTag) return;
      const want = (color || '').toLowerCase().trim();
      let firstVisibleIdx = -1;
      let checkedStillVisible = false;

      radios.forEach((radio, i) => {
        const tag = (radio.dataset.fpColor || '').toLowerCase().trim();
        const show = !tag || tag === want;
        radio.classList.toggle('fp-gallery__radio--hidden', !show);
        if (slides[i]) slides[i].classList.toggle('fp-gallery__slide--hidden', !show);
        if (thumbList[i]) thumbList[i].classList.toggle('fp-gallery__thumb--hidden', !show);
        if (show) {
          if (firstVisibleIdx === -1) firstVisibleIdx = i;
          if (radio.checked) checkedStillVisible = true;
        }
      });

      if (!checkedStillVisible && firstVisibleIdx !== -1) {
        radios[firstVisibleIdx].checked = true;
        if (thumbs) centerThumbInStrip(thumbList[firstVisibleIdx]);
      }
    }

    function getSelectedSwatchValue() {
      const checked = section.querySelector('.fp-swatch__input:checked');
      return checked ? (checked.dataset.fpSwatchValue || '') : '';
    }
    // Initial filter (in case a default swatch is preselected)
    filterGalleryByColor(getSelectedSwatchValue());

    /* === Swipe / drag-to-navigate on the main image (mobile + desktop) === */
    const main = section.querySelector('.fp-gallery__main');
    if (main) {
      main.style.touchAction = 'pan-y';
      main.style.cursor = 'grab';
      let downX = 0, downY = 0, dragging = false, abandoned = false;
      const SWIPE_PX = 40;

      let tStartX = 0, tStartY = 0, tHorizLocked = false;
      main.addEventListener('touchstart', (e) => {
        if (!e.touches || !e.touches.length) return;
        tStartX = e.touches[0].clientX;
        tStartY = e.touches[0].clientY;
        tHorizLocked = false;
      }, { passive: true });
      main.addEventListener('touchmove', (e) => {
        if (!e.touches || !e.touches.length) return;
        const dx = e.touches[0].clientX - tStartX;
        const dy = e.touches[0].clientY - tStartY;
        if (!tHorizLocked && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) tHorizLocked = true;
        if (tHorizLocked) e.preventDefault();
      }, { passive: false });

      main.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        downX = e.clientX;
        downY = e.clientY;
        dragging = true;
        abandoned = false;
        main.style.cursor = 'grabbing';
      });
      main.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - downX;
        const dy = e.clientY - downY;
        if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 12) {
          abandoned = true;
          dragging = false;
          main.style.cursor = 'grab';
          return;
        }
        if (e.pointerType === 'mouse' && Math.abs(dx) > 4) e.preventDefault();
      });
      const release = (e) => {
        if (!dragging && !abandoned) return;
        const wasDragging = dragging;
        dragging = false;
        main.style.cursor = 'grab';
        if (!wasDragging || abandoned) return;
        const dx = e.clientX - downX;
        if (dx <= -SWIPE_PX) setIndex(getCheckedIndex() + 1);
        else if (dx >= SWIPE_PX) setIndex(getCheckedIndex() - 1);
      };
      main.addEventListener('pointerup', release);
      main.addEventListener('pointercancel', () => { dragging = false; abandoned = false; main.style.cursor = 'grab'; });
      main.addEventListener('pointerleave', release);
    }

    // Variant swatch — update the form's variant ID, the price block, and the buy button
    // when a swatch is selected. Each swatch input carries data-fp-{price,compare,savings,
    // discount,available} for its variant, so we don't need to refetch product data.
    const swatchInputs = section.querySelectorAll('.fp-swatch__input');
    const form = section.querySelector('form[data-type="add-to-cart-form"]');
    const variantInput = form ? form.querySelector('input[name="id"]') : null;
    const selectedLabel = section.querySelector('[data-fp-selected-value]');

    const priceBlock = section.querySelector('[data-fp-price-block]');
    // When the price block is set to 'manual' via theme editor, freeze the price
    // values rendered server-side and skip the swatch-driven price refresh.
    const priceIsManual = priceBlock && priceBlock.getAttribute('data-fp-price-manual') === 'true';
    const priceCurrent = priceIsManual ? null : section.querySelector('[data-fp-price-current]');
    const priceCompare = priceIsManual ? null : section.querySelector('[data-fp-price-compare]');
    const priceSavings = priceIsManual ? null : section.querySelector('[data-fp-price-savings]');
    const priceSavingsAmount = priceIsManual ? null : section.querySelector('[data-fp-price-savings-amount]');
    const buyButton = section.querySelector('[data-fp-buy]');
    const buyMain = section.querySelector('[data-fp-buy-main]');
    const buyPrice = section.querySelector('[data-fp-buy-price]');

    function applyVariant(input) {
      const ds = input.dataset;
      if (variantInput && ds.fpSwatchVariant) variantInput.value = ds.fpSwatchVariant;
      if (selectedLabel && ds.fpSwatchValue) selectedLabel.textContent = ds.fpSwatchValue;

      const price = ds.fpPrice || '';
      const compare = ds.fpCompare || '';
      const savings = ds.fpSavings || '';
      const hasDiscount = ds.fpDiscount === 'true';
      const available = ds.fpAvailable === 'true';

      if (priceCurrent) priceCurrent.textContent = price;

      if (priceCompare) {
        if (hasDiscount && compare) {
          priceCompare.textContent = compare;
          priceCompare.removeAttribute('hidden');
        } else {
          priceCompare.setAttribute('hidden', '');
        }
      }

      if (priceSavings) {
        if (hasDiscount && savings) {
          if (priceSavingsAmount) priceSavingsAmount.textContent = savings;
          priceSavings.removeAttribute('hidden');
        } else {
          priceSavings.setAttribute('hidden', '');
        }
      }

      if (buyButton && buyMain) {
        // When the merchant typed a manual price into the buy_button block,
        // the rendered span carries the literal value — don't overwrite it on
        // swatch change. We still update available / disabled state and the
        // sold-out text path.
        const buyPriceManual = buyButton.dataset.fpBuyPriceManual === 'true';
        if (available) {
          buyButton.removeAttribute('disabled');
          if (buyPriceManual) {
            // Just ensure the manual price-span is present (sold-out path may
            // have wiped the structure). If so, rebuild with the existing
            // manual price text from the data attribute fallback.
            if (!buyMain.querySelector('[data-fp-buy-price]')) {
              const label = buyButton.dataset.fpBuyText || '';
              const manualText = buyButton.dataset.fpBuyPriceManualText || '';
              buyMain.textContent = label + ' - ';
              const span = document.createElement('span');
              span.setAttribute('data-fp-buy-price', '');
              span.textContent = manualText;
              buyMain.appendChild(span);
            }
          } else {
            const label = buyButton.dataset.fpBuyText || '';
            if (buyPrice) {
              // Reuse the existing structure: "<label> - <span data-fp-buy-price>price</span>"
              buyMain.firstChild && (buyMain.firstChild.nodeType === 3
                ? (buyMain.firstChild.nodeValue = label + ' - ')
                : null);
              if (!buyMain.querySelector('[data-fp-buy-price]')) {
                buyMain.textContent = label + ' - ';
                const span = document.createElement('span');
                span.setAttribute('data-fp-buy-price', '');
                span.textContent = price;
                buyMain.appendChild(span);
              } else {
                const span = buyMain.querySelector('[data-fp-buy-price]');
                span.textContent = price;
              }
            } else {
              buyMain.textContent = label + ' - ' + price;
            }
          }
        } else {
          buyButton.setAttribute('disabled', '');
          buyMain.textContent = buyButton.dataset.fpBuySoldout || '';
        }
      }
    }

    /* On mobile (<990px) when the customer picks a swatch, auto-scroll the page
       to the gallery so the updated image is visible. Desktop already shows the
       gallery + buy box side-by-side so no scroll is needed. */
    function scrollGalleryIntoViewIfMobile() {
      if (window.matchMedia('(min-width: 990px)').matches) return;
      const main = section.querySelector('.fp-gallery__main') || section.querySelector('.fp-gallery');
      if (!main) return;
      const headerOffset = 90;
      const top = main.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    /* Reset the gallery to the first visible image on every variant change, so
       customers see the 'hero' image of the picked variant instead of staying
       on whatever slide they previously navigated to. */
    function jumpGalleryToFirstVisible() {
      let firstVisible = -1;
      radios.forEach((r, i) => {
        if (firstVisible === -1 && !r.classList.contains('fp-gallery__radio--hidden')) firstVisible = i;
      });
      if (firstVisible === -1) return;
      if (!radios[firstVisible].checked) {
        radios[firstVisible].checked = true;
        radios[firstVisible].dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (thumbs && thumbList[firstVisible]) centerThumbInStrip(thumbList[firstVisible]);
    }

    swatchInputs.forEach((input) => {
      input.addEventListener('change', () => {
        applyVariant(input);
        filterGalleryByColor(input.dataset.fpSwatchValue || '');
        jumpGalleryToFirstVisible();
        scrollGalleryIntoViewIfMobile();
      });
    });
  });
})();

/* ============================================================
   Sticky add-to-cart bar
   Shows when no main [data-fp-buy] button is in the viewport.
   Clicks proxy to the main button so variant state, discount
   routing, and drawer-vs-checkout behavior all stay in sync.
   ============================================================ */
(function () {
  'use strict';

  function initStickyCart() {
    var bar = document.querySelector('[data-fp-sticky-cart]');
    if (!bar) return;

    var mainBuys = Array.prototype.slice.call(document.querySelectorAll('[data-fp-buy]'));
    if (!mainBuys.length) return;

    bar.hidden = false;

    // Mirror the main button's visible price into the sticky bar's price node
    // (the section's variant-change code updates [data-fp-buy-price] in place).
    var stickyPrice = bar.querySelector('[data-fp-sticky-price]');
    var mainPriceNode = document.querySelector('[data-fp-buy-price]');
    if (stickyPrice && mainPriceNode) {
      var sync = function () { stickyPrice.textContent = mainPriceNode.textContent; };
      sync();
      try {
        new MutationObserver(sync).observe(mainPriceNode, { childList: true, characterData: true, subtree: true });
      } catch (e) { /* noop */ }
    }

    // Mirror disabled/sold-out state
    var stickyBtn = bar.querySelector('[data-fp-sticky-add]');
    var stickyBtnText = bar.querySelector('.fp-sticky-cart__btn-text');
    function syncDisabled() {
      var primary = mainBuys[0];
      var disabled = primary && primary.hasAttribute('disabled');
      if (!stickyBtn) return;
      if (disabled) {
        stickyBtn.setAttribute('disabled', '');
        if (stickyBtnText) stickyBtnText.textContent = primary.getAttribute('data-fp-buy-soldout') || 'Sold out';
      } else {
        stickyBtn.removeAttribute('disabled');
        if (stickyBtnText) stickyBtnText.textContent = 'Add to cart';
      }
    }
    syncDisabled();
    if (mainBuys[0]) {
      try {
        new MutationObserver(syncDisabled).observe(mainBuys[0], { attributes: true, attributeFilter: ['disabled'] });
      } catch (e) { /* noop */ }
    }

    // Click → proxy to the primary main buy button (keeps form/variant state).
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.hasAttribute('disabled')) return;
        var primary = mainBuys[0];
        if (primary) primary.click();
      });
    }

    // Toggle visibility based on whether ANY main buy button is on-screen.
    var visibleCount = 0;
    if (typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visibleCount++;
        else visibleCount--;
      });
      if (visibleCount < 0) visibleCount = 0;
      if (visibleCount === 0) bar.classList.add('is-visible');
      else bar.classList.remove('is-visible');
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0.01 });
    mainBuys.forEach(function (b) { io.observe(b); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCart);
  } else {
    initStickyCart();
  }
})();
